import PostHogFunctions from '~/Classes/posthog'

const COMPLETED_KEY = 'mpz.mailchimpImport.phCompleted'
const FAILED_KEY = 'mpz.mailchimpImport.phFailed'

function jobKey(job) {
    if (!job) return null
    return job.jobId || job.startedAt || null
}

function readSet(storageKey) {
    try {
        const raw = window.sessionStorage.getItem(storageKey)
        if (!raw) return {}
        const parsed = JSON.parse(raw)
        return parsed && typeof parsed === 'object' ? parsed : {}
    } catch (err) {
        return {}
    }
}

function markOnce(storageKey, key) {
    if (!key || typeof window === 'undefined') return false
    const seen = readSet(storageKey)
    if (seen[key]) return false
    seen[key] = 1
    try {
        window.sessionStorage.setItem(storageKey, JSON.stringify(seen))
    } catch (err) { }
    return true
}

export function captureMailchimpImportInteracted(action) {
    PostHogFunctions.capture('mailchimp_import_interacted', { action })
}

export function captureMailchimpImportConnectClicked() {
    PostHogFunctions.capture('mailchimp_import_connect_clicked')
}

export function captureMailchimpImportPreviewViewed(discover) {
    const lists = (discover && discover.lists) || []
    const templates = (discover && discover.templates && discover.templates.items) || []
    const campaigns = (discover && discover.campaigns && discover.campaigns.items) || []
    const obvious = (discover && discover.fields && discover.fields.obvious) || []
    const create = (discover && discover.fields && discover.fields.create) || []
    PostHogFunctions.capture('mailchimp_import_preview_viewed', {
        audiences_available: lists.length,
        templates_available: templates.length,
        campaigns_available: campaigns.length,
        fields_available: obvious.length + create.length
    })
}

/**
 * @param {{ listIds?: any[], templateIds?: any[], campaignIds?: any[], fieldTags?: any[], importAgain?: boolean }} selection
 */
export function captureMailchimpImportStarted(selection) {
    const listIds = (selection && selection.listIds) || []
    const templateIds = (selection && selection.templateIds) || []
    const campaignIds = (selection && selection.campaignIds) || []
    const fieldTags = (selection && selection.fieldTags) || []
    PostHogFunctions.capture('mailchimp_import_started', {
        audiences_selected: listIds.length,
        templates_selected: templateIds.length,
        campaigns_selected: campaignIds.length,
        fields_selected: fieldTags.length,
        import_again: !!(selection && selection.importAgain)
    })
}

export function captureMailchimpImportBackgrounded(job) {
    PostHogFunctions.capture('mailchimp_import_backgrounded', {
        percent_complete: (job && job.percentComplete) || 0,
        stage: (job && job.stage) || null
    })
}

export function captureMailchimpImportCompleted(job) {
    const key = jobKey(job)
    if (!markOnce(COMPLETED_KEY, key || 'complete')) return false
    const counts = (job && job.counts) || {}
    PostHogFunctions.capture('mailchimp_import_completed', {
        contacts_created: counts.subscribers || 0,
        contacts_updated: counts.subscribersUpdated || 0,
        groups: counts.groups || 0,
        groups_updated: counts.groupsUpdated || 0,
        fields: counts.fields || 0,
        fields_updated: counts.fieldsUpdated || 0,
        templates: counts.templates || 0,
        templates_updated: counts.templatesUpdated || 0,
        campaigns: counts.campaigns || 0,
        campaigns_updated: counts.campaignsUpdated || 0,
        images: counts.images || 0,
        images_updated: counts.imagesUpdated || 0,
        audiences: ((job && job.listIds) || []).length
    })
    // Align with other integration import funnels
    PostHogFunctions.capture('import_completed', { source: 'mailchimp' })
    return true
}

export function captureMailchimpImportFailed(job) {
    const key = jobKey(job)
    if (!markOnce(FAILED_KEY, key || 'failed')) return false
    PostHogFunctions.capture('mailchimp_import_failed', {
        stage: (job && job.stage) || null,
        stage_label: (job && job.stageLabel) || null,
        percent_complete: (job && job.percentComplete) || 0
    })
    return true
}

/** @private test helper */
export function _resetMailchimpImportAnalyticsForTests() {
    try {
        window.sessionStorage.removeItem(COMPLETED_KEY)
        window.sessionStorage.removeItem(FAILED_KEY)
    } catch (err) { }
}
